import styled from 'styled-components';

import { FieldComponent } from 'libs/form';
import { Button } from 'libs/ui';

export const Screen = styled.div`
  position: fixed;
  inset: 0;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  transition: background 0.25s ease;
  background: ${(props) =>
    props.theme.theme === 'dark'
      ? `radial-gradient(circle at 15% 20%, rgba(92, 201, 138, 0.14) 0%, transparent 42%),
         radial-gradient(circle at 85% 80%, rgba(71, 185, 114, 0.1) 0%, transparent 48%),
         linear-gradient(150deg, #060a08 0%, #0c1210 55%, #0a1310 100%)`
      : `radial-gradient(circle at 15% 20%, rgba(71, 185, 114, 0.1) 0%, transparent 42%),
         radial-gradient(circle at 85% 80%, rgba(92, 201, 138, 0.12) 0%, transparent 48%),
         linear-gradient(150deg, #eef3ee 0%, #f5f8f5 55%, #eaf1ea 100%)`};
`;

export const Card = styled.div`
  position: relative;
  display: flex;
  align-items: stretch;
  width: 820px;
  max-width: 100%;
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.55), 0 0 0 1px rgba(92, 201, 138, 0.14);
`;

export const Left = styled.div`
  flex: 1 1 46%;
  min-width: 300px;
  padding: 34px 30px 26px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: radial-gradient(140% 120% at 80% 0%, rgba(71, 185, 114, 0.16) 0%, transparent 50%), #0b110e;
`;

export const LoginLogo = styled.img`
  display: block;
  height: 54px;
  width: auto;
`;

export const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Logo = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #5cc98a 0%, #47b972 60%, #3aa863 100%);
  box-shadow: 0 3px 14px rgba(71, 185, 114, 0.4);
  color: #fff;
  font-weight: 800;
  font-size: 24px;
  line-height: 1;
`;

export const BrandName = styled.div`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.3px;
  color: #f2f6f3;
  span {
    color: #5cc98a;
  }
`;

export const BrandSub = styled.div`
  font-size: 10.5px;
  color: rgba(242, 246, 243, 0.5);
  letter-spacing: 1.4px;
  text-transform: uppercase;
`;

export const Tagline = styled.div`
  margin-top: 18px;
  font-size: 12.5px;
  line-height: 1.6;
  color: rgba(242, 246, 243, 0.55);
  max-width: 300px;
`;

export const GateWrap = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 18px;
`;

export const Right = styled.div`
  flex: 1 1 54%;
  min-width: 300px;
  padding: 38px 36px 30px;
  background: var(--cp-surface);
  display: flex;
  flex-direction: column;
`;

export const RightTitle = styled.h4`
  margin: 0 0 24px;
  font-size: 18px;
  font-weight: 600;
  color: var(--cp-text);
`;

export const StyledField = styled(FieldComponent)`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  label {
    font-size: 12px;
    color: var(--cp-text-secondary);
    margin-bottom: 6px;
  }
  input {
    height: 44px;
    padding: 10px 12px;
    width: 100%;
    color: var(--cp-text);
    background: var(--cp-surface);
    border: 1px solid ${(props) => (props.error ? '#cc2936' : 'var(--cp-border)')};
    border-radius: 10px;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
    &:focus {
      outline: none;
      border-color: var(--cp-green);
      box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.12);
    }
    &::placeholder {
      color: var(--cp-text-tertiary);
    }
  }
`;

export const ErrorMsg = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 10px 12px;
  border-radius: 10px;
  font-size: 13px;
  color: #cc2936;
  background: rgba(204, 41, 54, 0.08);
  border: 1px solid rgba(204, 41, 54, 0.25);
`;

export const Submit = styled(Button)`
  height: 46px;
  width: 100%;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  border: none;
  border-radius: 12px;
  background: ${(props) => (props.$opened ? 'linear-gradient(90deg, #47b972 0%, #3aa863 100%)' : 'linear-gradient(90deg, #5cc98a 0%, #47b972 100%)')};
  box-shadow: 0 4px 16px rgba(71, 185, 114, 0.3);
  opacity: ${(props) => (props.disabled ? '0.6' : '1')};
  transition: filter 0.15s ease;
  &:hover:not(:disabled) {
    filter: brightness(1.03);
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px solid var(--cp-border-soft);
`;

export const FooterTools = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
